import React from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import ErrorPageImage from '../../assets/404.png'


const MissingPage = (props) => {
    const {logStatus, ...others} = props

    return (
        <Box ml='90px' >
            <Toolbar />
            <Box
                sx={{
                    height: '90vh',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'text.primary',
                }}
            >
                {/* <img src={ErrorPageImage} alt="Page not found" style={{width: 'auto', height:'auto'}} /> */}
                <h1>404</h1>
                <h2>Page Not Found</h2>
                <p>Sorry, the page you are looking for does not exist.</p>
            </Box>
        </Box >
    );
}

export default MissingPage;